export default __webpack_public_path__ + "static/media/data-sharing-icon.8e3a6a26.svg";